import { answerFromStoredMessage } from 'actions/team_assist_v2/lib/team_assist_v2_answer';

/**
 * The turns of a stored session, from the load route's `messages`: each agent
 * question with its answer and any surfaced tool results. glados returns only
 * answered questions, so a question without an answer is left out.
 */
export default function mapTeamAssistV2Session(messages = []) {
  const answersByQuestionId = {};
  const executionsByToolUseId = {};
  messages.forEach(message => {
    if (message.role === 'assistant' && message.questionId) {
      answersByQuestionId[message.questionId] = message;
    } else if (message.role === 'tool' && message.kind === 'tool_executed') {
      executionsByToolUseId[message.toolUseId] = {
        result: message.result,
        resultType: message.resultType || null,
        isError: message.isError === true,
      };
    }
  });

  return messages
    .filter(message => message.role === 'agent' && answersByQuestionId[message.id])
    .map(question => ({
      id: question.id,
      question: (question.question && question.question.text) || '',
      displayedMessage: question.displayedMessage,
      conversationId: question.conversationId,
      answer: answerFromStoredMessage(answersByQuestionId[question.id], executionsByToolUseId),
      live: false,
    }));
}
